import $ from 'jquery';
import {loadStripeSDK} from '@wc-stripe/stripe-sdk';
import {isNextActionRequired} from '@wc-stripe/utils';

let stripe;

let data = {};

const initialize = () => {
    $(document).on('wfocu_external', onHandleSubmit);
    window.addEventListener('hashchange', handleHashChange);
    wfocuCommons.addFilter('wfocu_front_charge_data', addChargeData);
}

const onBucketCreated = (e, bucket) => {
    data = window?.wfocu_vars?.stripeData;
    setData('bucket', bucket);
    initialize();
}

$(() => {
    loadStripeSDK().then((client) => {
        stripe = client;
    }).catch(error => {
        console.log(error);
    });
});

const onHandleSubmit = (e, bucket) => {
    setData('bucket', bucket);
}

const handleHashChange = (e) => {
    const data = isNextActionRequired(e.newURL);
    if (data) {
        getData('bucket')?.swal?.hide();
        setData('paymentIntent', data.payment_intent);
        history.pushState({}, '', window.location.pathname + window.location.search);
        stripe.confirmPayment({
            clientSecret: data.client_secret,
            redirect: 'if_required',
        }).then(response => {
            if (response.error) {
                // display message
                resetPaymentProcess();
            } else {
                setData('paymentComplete', true);
                getData('bucket').sendBucket();
            }
        }).catch(error => {
            console.log(error);
        });
    }
}

const addChargeData = (e) => {
    e['_payment_intent'] = getData('paymentIntent');
    return e;
}

const getData = (key, defaultValue = null) => {
    if (!data.hasOwnProperty(key)) {
        data[key] = defaultValue;
    }
    return data[key];
}

const setData = (key, value) => {
    data[key] = value;
}

const resetPaymentProcess = () => {
    getData('bucket').inOfferTransaction = false;
    getData('bucket').EnableButtonState();
    getData('bucket').HasEventRunning = false;
}

$(document).on('wfocuBucketCreated', onBucketCreated);